export enum ExotelReduceActions {
  UPDATE_API_KEY,
  UPDATE_API_TOKEN,
  UPDATE_ACCOUNT_SID,
  UPDATE_SUBDOMAIN,
  UPDATE_VOICE_BOT_APP_ID,
  ADD_PHONE_NUMBER,
  UPDATE_PHONE_NUMBER,
  REMOVE_PHONE_NUMBER,
  SET_STATE,
  VALIDATE_STATE
}